

<template>
  <div class="card bg-white col-4">
    <div style="background-color: #3742FA;"  class="card-header  text-white"> <h5 class="text-white" style="font-size: 1.6vw !important;">فرآیند</h5></div>
    <center class="mt-3">
      <input  v-model="search" @change="allItems"  type="text" class="form-control w-75" placeholder="جستجو بر اساس  فرآیند..."  >
      <hr class="w-75 m-3">
    </center>
    <center>
      <div class="w-75">
        <div v-for="item in allItem" class="bg-white d-flex align-items-center justify-content-center flex-row bg-white p-1">
          <img style="transform: translateY(-.5vw) translateX(4vw);     width: 1.3vw;" src="/img/doc.png" alt="">
          <p  style="margin-right: 2vw;transform: translateY(.2vw) translateX(5vw);; ">  {{item.name}}  </p>
        </div>

      </div>
    </center>
  </div>
</template>
<script  >
export  default {
  data(){
    return{
      allItem: [],
      search: ''
    }
  },
  methods:{
    allItems(){
      var myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      var formdata = new FormData();
      formdata.append('search', this.search)


      var requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };
      fetch(`${this.base_url}/process_documentation_management/process`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.all){
              this.allItem.length=0
              response.all.forEach((item)=>{
                this.allItem.push(item)
              })
            }


          })
          .catch();

    },
  },



}
</script>
<style scoped>

</style>